import { createColumnBoolean, createColumnInput } from "../../../components/table/c-table.logic";
import i18n from "../../../i18n";

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.notification.title"), dataIndex: "title" }),
        createColumnInput({ title: () => i18n.global.t("model.notification.desc"), dataIndex: "desc" }),
        createColumnBoolean({ title: () => i18n.global.t("model.notification.isRead"), dataIndex: "isRead" }),
    ];
    return columns;
};
